import { useTranslations } from 'next-intl';

const getWinners = (winners: number | undefined, t: ReturnType<typeof useTranslations>) => {
  return typeof winners === 'undefined' || winners === 0 ? t('results_winners_missing_value') : t('results_winners', { winners });
};

function useGetWinners(namespace: string) {
  const t = useTranslations(namespace);
  return (winners: number | undefined) => getWinners(winners, t);
}

export { useGetWinners };
